export default function() {
  return {
    type: 'INITIAL_PAGE_LOAD',
    initialPageLoad: false
  };
}
